import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  RequiredUserAction,
  RequiredUserActionParams,
  RequiredUserActionValidator,
} from '../required-user-action-service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { AlertService } from '../../alert/alert.service';
import { LoadingService } from '../../loading/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';

@Injectable({
  providedIn: 'root',
})
export class PhotodocRequiredUserAction implements RequiredUserActionValidator {
  // Public Member
  public readonly type: RequiredUserAction = 'photodoc';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private remoteActionService: RemoteActionService,
    private clientStateService: ClientStateService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private servicejobsService: ServicejobsService,
    private jobsectionsService: JobSectionsService,
  ) {}

  // RequiredUserActionService
  public async isFullfilled(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    this.logger.log(
      this.constructor.name,
      'isFullfilled with',
      params,
      params.forjobsections,
    );

    const remoteActions =
      this.remoteActionService.remoteActions$.getValue() ?? [];
    this.logger.log("JBFLKPhoto available remoteActions", remoteActions)
    const transmittedRemoteActions =
      this.remoteActionService.transmittedRemoteActions$.getValue() ?? [];
    this.logger.log("JBFLKPhoto available transmitted remoteActions", transmittedRemoteActions)

    let photoFound = false;
    photoFound =
      photoFound ||
      (await this.searchPhotoInRemoteActions(remoteActions, params));
    this.logger.log("JBFLKPhoto found in remoteActions?", photoFound, "with params", params)
    photoFound =
      photoFound ||
      (await this.searchPhotoInRemoteActions(transmittedRemoteActions, params));
    this.logger.log("JBFLKPhoto found in transmittedRemoteActions?", photoFound, "with params", params)

    this.logger.log(this.constructor.name, 'JBFLKPhoto isFullfilled result', photoFound);
    return photoFound;
  }

  public async showSoftWarning(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    await this.loadingService.dismissLoading();
    const returnPromise = new Promise<boolean>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.SOFT.TITLE'),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.PHOTODOC.SOFT.MESSAGE',
          this.getTranslateObjectForParams(params),
        ),
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.SOFT.CONFIRM'),
        async () => {
          await this.loadingService.showLoading();
          resolve(true);
        },
        async () => {
          await this.loadingService.showLoading();
          resolve(false);
        },
        [],
        true,
        undefined,
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.SOFT.CANCEL'),
        [],
      );
    });

    return returnPromise;
  }
  public async showHardWarning(
    params: RequiredUserActionParams,
  ): Promise<void> {
    await this.loadingService.dismissLoading();
    const returnPromise = new Promise<void>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.HARD.TITLE'),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.PHOTODOC.HARD.MESSAGE',
          this.getTranslateObjectForParams(params),
        ),
        undefined,
        undefined,
        async () => {
          await this.loadingService.showLoading();
          resolve();
        },
        [],
        true,
        undefined,
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.HARD.CANCEL'),
        [],
      );
    });

    return returnPromise;
  }

  // Private Functions
  private getTranslateObjectForParams(params: RequiredUserActionParams): any {
    let transObject = {};
    const clientState = this.clientStateService.theState.getValue();

    if (params.forjobsections && clientState.jobSectionId != null) {
      transObject['object'] =
        this.jobsectionsService.getJobSectionById(clientState.jobSectionId)
          ?.displayLabel ??
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.UNKNOWN-OBJECT');
    } else if (clientState.serviceJobId != null) {
      transObject['object'] =
        this.servicejobsService.getServiceJobById(clientState.serviceJobId)
          ?.displayLabel ??
        this.translate.instant('REQUIRED-USER-ACTION.PHOTODOC.UNKNOWN-OBJECT');
    } else {
      transObject['object'] = this.translate.instant(
        'REQUIRED-USER-ACTION.PHOTODOC.UNKNOWN-OBJECT',
      );
    }

    return transObject;
  }
  private async searchPhotoInRemoteActions(
    remoteActions: RemoteAction[],
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    const clientState = this.clientStateService.theState.getValue();
    const curJobSection = clientState?.jobSectionId;

    for (const remoteAct of remoteActions) {
      this.logger.log("JBFLKPhoto check remote action with endpoint", remoteAct.endpoint)
      if (remoteAct.endpoint == 'photodoc' || remoteAct.endpoint == 'v2/photodoc') {
        if (params == null || params.forjobsections == null) {
          this.logger.log("JBFLKPhoto found and no jobsection required!")
          return true;
        } else {
          this.logger.log("JBFLKPhoto found now check for jobsection?", remoteAct.data['jobsectionid'])
          const remoteActionFound =
            remoteAct.data['jobsectionid'] == curJobSection.imsId;
          this.logger.log("JBFLKPhoto matches cur jobsection?", curJobSection.imsId, remoteActionFound)
          if (remoteActionFound) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
